const styles = (theme) => ({
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  counterInfo: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.backgrounds.cardBackground,
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    padding: '11px 17px',
    maxWidth: 310,
    width: '100%',
  },
  title: {
    fontSize: '18px',
    color: '#929292',
  },
  info: {
    fontSize: '15px',
  },
  counter: {
    backgroundColor: theme.backgrounds.cardBackground,
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 50,
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 310,
    width: '100%',
    padding: '15px 8px',
  },
  counterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '20%',
  },
  counterTitle: {
    fontSize: '16px',
  },
  buttonInc: {
    transform: 'rotate(-90deg)',
  },
  buttonDec: {
    transform: 'rotate(90deg)',
  },
  number: {
    fontSize: '18px',
  },
})

export default styles
